import { getHotelItem, getHotelItems } from 'supportAssistant/utils/orderUtils'
import LesaPurchaseSummaryOrderItemStatus from './Common/LesaPurchaseSummaryOrderItemStatus'
import Group from 'components/utils/Group'
import {
  INTL_DAY_MONTH_NAME_SHORT,
  INTL_DMY_CASUAL_SHORT_FORMAT,
} from 'constants/dateFormats'
import { RESERVATION_STATE_PENDING } from 'constants/reservation'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import { ITEM_STATUS_AWAITING_DATES, ORDER_STATUS_COMPLETED } from 'constants/cart'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'

export const InlineContainer = styled(Group)`
  > * + *::before {
    content: '·';
    margin: 0 ${rem(4)};
    speak-as: bullets;
    speak: none;
  }
`

interface Props {
  order: App.Order
  isTour: boolean
}

export default function LesaHotelPurchaseItem({ isTour, order }: Props) {
  const intl = useIntl()
  const dateFormatter = useIntlDateFormatter()
  const items = getHotelItems(order)
  const item = getHotelItem(order)

  let status = item.status

  if (isTour && item.reservation) {
    if (item.onHold) {
      status = ITEM_STATUS_AWAITING_DATES
    } else if (order.status === ORDER_STATUS_COMPLETED && item.reservation.state === RESERVATION_STATE_PENDING) {
      status = RESERVATION_STATE_PENDING
    } else if (item.reservation.travellerDetailsRequired) {
      status = 'needsDetails'
    }
  }

  const startDate = item.reservation?.startDate
    ? dateFormatter(item.reservation.startDate, INTL_DAY_MONTH_NAME_SHORT)
    : undefined
  const endDate = item.reservation?.endDate
    ? dateFormatter(item.reservation.endDate, INTL_DMY_CASUAL_SHORT_FORMAT)
    : undefined
  const dateString = startDate && endDate ? intl.formatMessage(
    {
      id: '9DZSQt2ZEPd9sddIoh7t',
      defaultMessage: '{startDate} - {endDate}',
      description: 'Hotel stay date range shown in the support assistant purchase summary item',
    },
    {
      startDate,
      endDate,
    },
  ) : undefined
  const showDates = !item.onHold && item.reservation && item.reservation.state !== RESERVATION_STATE_PENDING && dateString

  const duration = item.duration && item.durationLabel

  const rooms = items.length
  const roomString = rooms ? intl.formatMessage({
    id: '7NM5EUk28Yj-1WHjO-b5',
    defaultMessage: '{count, plural, one {# room} other {# rooms}}',
    description: 'Number of rooms for hotel purchase item on the hotel or room booking page',
  }, { count: rooms }) : undefined

  return (
    <InlineContainer direction="horizontal">
      {!startDate && <LesaPurchaseSummaryOrderItemStatus status={status} />}
      {showDates && <BodyText variant="small" colour="light-foreground-alt">{dateString}</BodyText>}
      {duration && <BodyText variant="small" colour="light-foreground-alt">{duration}</BodyText>}
      {roomString && <BodyText as="span" variant="small" colour="light-foreground-alt">{roomString}</BodyText>}
    </InlineContainer>
  )
}
